import { combineReducers } from 'redux'

import alert from './alert'
import modal from './modal'
import contact from './contact'
import settingReferral from './settingReferral'

export default combineReducers({
  alert: alert,
  modal: modal,
  contact: contact,
  settingReferral: settingReferral
})
